import type { ViewComponent } from "@frui.ts/views";
import type ChargeDetailInfoViewModel from "viewModels/callCenter/search/charges/chargeDetail/chargeDetailInfoViewModel";
import { observer } from "mobx-react-lite";
import SourceType from "entities/sourceType";
import { Col, Form } from "react-bootstrap";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import React from "react";
import OrderSourceTypeGroup from "./orderSourceTypeGroup";
import { emptyValueFormatter } from "./index";
import { formatAmount } from "utils/localizations";

const EshopOrderSection: ViewComponent<ChargeDetailInfoViewModel> = observer(({ vm }) => {
  const order = vm.item.chargeOrderDetail;
  const isTransferType = !!vm.item.chargeOrderDetail.eshopTransferOrderDetail;
  const payGatePayment = order.eshopPayGateOrderDetail?.payGatePayment;
  const transferDetail = order.eshopTransferOrderDetail;
  let sourceOrderDetail = null;
  let orderPriceGroup;

  if (order?.isBulkChargeOrder) {
    orderPriceGroup = (
      <Form.Group as={Col} md={6} xl={4}>
        <Form.Label>{vm.translateSubAttribute("singleChargeOrderDetailResponse", "price")}</Form.Label>
        <FakeInput target={order} property="price" valueFormatter={formatAmount} />
      </Form.Group>
    );
  }

  if (order.sourceType === SourceType.Eshop && !isTransferType && payGatePayment) {
    sourceOrderDetail = (
      <>
        <OrderSourceTypeGroup vm={vm} />
        <Form.Group as={Col} md={6} xl={8}>
          <Form.Label>{vm.translateSubAttribute("payGatePayment", "arn")}</Form.Label>
          <FakeInput target={payGatePayment} property="arn" valueFormatter={emptyValueFormatter} />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("singleChargeOrderDetailResponse", "chargeOrderPaymentDisplayType")}</Form.Label>
          <FakeInput
            target={order}
            property="chargeOrderPaymentDisplayType"
            valueFormatter={value => vm.translatePaymentDisplayType(value)}
          />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("payGatePayment", "cardNumber")}</Form.Label>
          <FakeInput target={payGatePayment} property="cardNumber" valueFormatter={emptyValueFormatter} />
        </Form.Group>
        <Form.Group as={Col} md={3}>
          <Form.Label>{vm.translateSubAttribute("payGatePayment", "authCode")}</Form.Label>
          <FakeInput target={payGatePayment} property="authCode" valueFormatter={emptyValueFormatter} />
        </Form.Group>
        <Form.Group as={Col} md={5}>
          <Form.Label>{vm.translateSubAttribute("payGatePayment", "payGatePaymentIdent")}</Form.Label>
          <FakeInput target={payGatePayment} property="payGatePaymentIdent" valueFormatter={emptyValueFormatter} />
        </Form.Group>
        {orderPriceGroup}
      </>
    );
  } else if (order.sourceType === SourceType.Eshop && isTransferType) {
    sourceOrderDetail = (
      <>
        <OrderSourceTypeGroup vm={vm} />
        <Form.Group as={Col} md={6} xl={4}>
          <Form.Label>{vm.translateSubAttribute("singleChargeOrderDetailResponse", "chargeOrderPaymentDisplayType")}</Form.Label>
          <FakeInput
            target={order}
            property="chargeOrderPaymentDisplayType"
            valueFormatter={value => vm.translatePaymentDisplayType(value)}
          />
        </Form.Group>
        {orderPriceGroup}
        <Form.Group as={Col} md={12}>
          <Form.Label>{vm.translateSubAttribute("eshopTransferOrderDetailResponse", "counterpartyBankAccount")}</Form.Label>
          <FakeInput
            target={transferDetail}
            property="counterpartyBankAccount"
            valueFormatter={value => formatBankAccount(value)}
          />
        </Form.Group>
      </>
    );
  }

  return sourceOrderDetail;
});

export default EshopOrderSection;
